export function useInsertAtCursor(
  textareaId: string,
  getValue: () => string,
  setValue: (next: string) => void,
) {
  return (token: string) => {
    const textarea = document.getElementById(textareaId) as HTMLTextAreaElement | null;
    const value = getValue();
    const start = textarea?.selectionStart ?? value.length;
    const end = textarea?.selectionEnd ?? start;
    const caret = start + token.length;
    setValue(value.slice(0, start) + token + value.slice(end));
    requestAnimationFrame(() => {
      textarea?.focus();
      textarea?.setSelectionRange(caret, caret);
    });
  };
}
